import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import PropTypes from "prop-types";
import "../TextFieldComponent/TextFieldComponent.css";

const AutoCompleteComponent = ({selectedList, options, setSelectedList, setTargetList, label}) => {
	return (<div className="box">
		<label className="left"> {label}: </label>
		<Autocomplete
			className="right"
			multiple
			id={`${label}-autocomplete}`}
			value={selectedList}
			options={options}
			disableCloseOnSelect
			getOptionLabel={option => option.label}
			onChange={(_event, newValue) => {
				setSelectedList(newValue);
				let targetList = [];
				[...newValue].forEach(record => targetList.push(record.value));
				setTargetList(targetList);
			}}
			isOptionEqualToValue={(option,value) => {
				return option.value === value.value;
			}}
			// renderTags={() => null}
			renderOption={(props, option, { selected }) => (
				<li {...props}>
					{option.label}
				</li>
			)}
			renderInput={params => ( <TextField {...params} placeholder={`Search ${label}`} /> )
			}
		/>
	</div>);
};

AutoCompleteComponent.propTypes = {
	selectedList: PropTypes.array,
	options: PropTypes.array,
	setSelectedList: PropTypes.func,
	setTargetList: PropTypes.func,
	label: PropTypes.string
};

AutoCompleteComponent.defaultProps = {
	selectedList: [],
	options: [],
	setSelectedList: null,
	setTargetList: null,
	label: ""
};

export default AutoCompleteComponent;
